import { combineReducers } from "redux";

import account  from "./account";
import updateAccount from "./updateAccount";
import verifyEmail from "./verify";
import archive, { unarchive } from "./archive";
import attribute_types, {attributes, addAttributes, editDocAttributes, editAttribute, editDocsAttributes, deleteAttribute} from "./attributes";
import auth from "./auth";
import app from "./app";
import diia from "./diia";
import docs from "./docs";
import ite from "./ite";
import menu from "./menu";
import sign from "./sign";
import view from "./view";
import whoami from "./whoami";
import upload from "./upload";
import filter from "./filter";
import storage from "./storage";
import types, {editTypes} from "./types";
import { signerAdd, signerDelete } from "./signer";
import cancelDoc from "./cancel";
import deleteDoc from "./delete";
import contactsList, { contactsPost, contactsDelete, contactsSearch } from "./contacts";


export default combineReducers({
  account,
  updateAccount,
  verifyEmail,
  // accountSwitch: accountSwitchReducer,
  archive,
  unarchive,
  attribute_types,
  attributes,
  addAttributes,
  editDocAttributes,
  contactsList,
  contactsPost,
  contactsDelete,
  contactsSearch,
  editDocsAttributes,
  editAttribute,
  deleteAttribute,
  cancelDoc,
  deleteDoc,
  auth,
  app,
  diia,
  docs,
  ite,
  menu,
  sign,
  user: whoami,
  view,
  upload,
  filter,
  storage,
  signerAdd,
  signerDelete,
  types,
  editTypes
});
